
    import "src/shared/components/FormLayout/index.module.scss?farm_css_modules";
    
    export default {"button": `button-9d2dd575`,"form": `form-9d2dd575`,"formItem": `formItem-9d2dd575`,"icon": `icon-9d2dd575`,"input": `input-9d2dd575`,"main": `main-9d2dd575`,"orderInfoContainer": `orderInfoContainer-9d2dd575`,"row4": `row4-9d2dd575`}
    